import type { JSentinelMessage, JSentinelReason } from "../types";

export function emit(message: JSentinelMessage) {
  window.dispatchEvent(
    new CustomEvent("jsentinel", {
      detail: message,
      bubbles: true,
      composed: true,
    }),
  );
}

// ---- safe tamper emit (log + buffer + event) ----
const __tamperLog: JSentinelMessage[] = [];

export function emitSafeTamper(reason: JSentinelReason) {
  const payload: JSentinelMessage = {
    type: "tamper.jsentinel",
    data: { reason, ts: Date.now() },
  };

  __tamperLog.push(payload);
  if (__tamperLog.length > 50) __tamperLog.shift();

  try {
    console.warn("[JSentinel] TAMPER", payload);
  } catch {}
  try {
    // emit directly to make spying on dispatchEvent possible in tests
    window.dispatchEvent(
      new CustomEvent("jsentinel", {
        detail: payload,
        bubbles: true,
        composed: true,
      }),
    );
  } catch {}
}

export function onJSentinel<T extends JSentinelMessage["type"]>(
  type: T,
  handler: (data: Extract<JSentinelMessage, { type: T }>["data"]) => void,
) {
  const h = (e: Event) => {
    const ce = e as CustomEvent<JSentinelMessage>;
    if (ce.detail?.type === type) handler(ce.detail.data as any);
  };
  window.addEventListener("jsentinel", h as EventListener);
  return h;
}

export function onJSentinelAny(handler: (msg: JSentinelMessage) => void) {
  const h = (e: Event) => handler((e as CustomEvent<JSentinelMessage>).detail);
  window.addEventListener("jsentinel", h as EventListener);
  return h;
}

export function offJSentinel(listener: EventListener) {
  window.removeEventListener("jsentinel", listener);
}
